import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
`

export const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 680px;
  height: auto;
  gap: 10px;
  padding-top: 0px;
  margin-bottom: 20px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  gap: 5px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`
